// import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import {
  IConsultDetails,
  ProductPreviewTypes,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import { FieldValues, UseFormReturn } from "react-hook-form";
import DetailsAddToCartBtn from "../details-add-to-cart-btn/DetailsAddToCartBtn";
import dynamic from "next/dynamic";
// Calendar-service components render only for appointment/consultation/service
// product types and pull `timezone-utils` → `moment-timezone` (~708KB). Lazy-load
// them so a normal product page never ships that in its initial bundle.
const CalendarNotAvailable = dynamic(
  () =>
    import(
      "@/app/components/common-builder/calendar-service/calendar/calendar-not-available/CalendarNotAvailable"
    ),
  { ssr: false },
);
const Calendar = dynamic(
  () => import("@/app/components/common-builder/calendar-service/calendar/Calendar"),
  { ssr: false },
);
const CalendarPopUp = dynamic(
  () => import("@/app/components/common-builder/calendar-service/calendar/calendar-popup"),
  { ssr: false },
);

const ConsultationForm = dynamic(
  () =>
    import(
      "@/app/components/common-builder/consultation-service/consult-form/ConsultationForm"
    ),
  { ssr: false },
);
const DetailsRedirectTo = dynamic(() => import("./DetailsRedirectTo"), {
  ssr: false,
});

interface Props {
  productState: IuseProductHasAttrsResult;
  form: UseFormReturn<FieldValues, any>;
  isPopupMobile: boolean;
  agreeTerms?: boolean;
  popup?: "normal" | "configrable" | false;
  beside?: boolean;
  showCalenderAsPopup?: boolean;
  variant?: "default" | "vto";
  sessionId?: number | string | null;
}
const SpecificProduct: React.FC<Props> = ({
  productState,
  form,
  isPopupMobile,
  agreeTerms,
  popup = false,
  beside,
  showCalenderAsPopup,
  variant = "default",
  sessionId,
}) => {
  const t = useTranslation();
  const { currentProd } = productState;

  switch (currentProd?.preview_type) {
    case ProductPreviewTypes.consultation:
      return (
        <>
          <ConsultationForm
            product={currentProd as IConsultDetails}
            isDetails
            productState={productState}
          />
          <DetailsRedirectTo
            text={`${t.looking_for_earlier_consultations_go_to} `}
            link={{ text: t.my_consultations, href: "" }}
          />
        </>
      );
    case ProductPreviewTypes.appointment:
      return (
        <div
          className={`d-flex ${
            beside ? "flex-row" : "flex-column"
          } justify-content-center align-items-center`}
          style={{ gap: beside ? 0 : 24 }}
        >
          {/* {productState.cartDisabled ? (
            <CalendarNotAvailable form={form} productState={productState} />
          ) : (
            <CalendarPopUp
              form={form}
              product={currentProd}
              productState={productState}
              disabled={productState.cartDisabled}
            />
          )} */}
          {showCalenderAsPopup ? (
            <CalendarPopUp
              form={form}
              product={currentProd}
              productState={productState}
              disabled={productState.cartDisabled}
            />
          ) : productState.cartDisabled ? (
            <CalendarNotAvailable form={form} productState={productState} />
          ) : (
            <Calendar
              form={form}
              product={currentProd}
              productState={productState}
              beside={beside}
            />
          )}

          <DetailsRedirectTo
            text={`${t.looking_for_earlier_appointments_go_to} `}
            link={{ text: t.my_appointments, href: "" }}
          />
        </div>
      );
    default: //ProductPreviewTypes.general
      return (
        <DetailsAddToCartBtn
          form={form}
          agreeTerms={agreeTerms!}
          productState={productState}
          isPopupMobile={isPopupMobile}
          popup={popup}
          variant={variant}
          sessionId={sessionId!}
        />
      );
  }
};

export default SpecificProduct;
